<template>
<div class="travel-page">
  <header-nav></header-nav>

  <div class="travel-game">
    <div class="game-wrap" ref="gameWrap">
    <canvas ref="gameCanvas"></canvas>

    <div class="boss-bar" v-if="bossActive">
      <span class="boss-label">BOSS</span>
      <div class="boss-bar-track"><div class="boss-bar-fill" :style="{ width: bossHpPct + '%' }"></div></div>
    </div>

    <div class="hud hud-bottom" v-if="started && !gameOver">
      <div class="hud-score">
        <span class="hud-label">SCORE</span>
        <span class="hud-value">{{ score }}</span>
      </div>
      <div class="hud-hp">
        <span class="hud-label">HP</span>
        <div class="hp-bar"><div class="hp-fill" :style="{ width: hpPercent + '%' }"></div></div>
      </div>
      <div class="hud-shield">
        <span class="hud-label">晶体护盾</span>
        <div class="hp-bar shield-bar"><div class="hp-fill shield-fill" :style="{ width: shieldCharge + '%' }"></div></div>
      </div>
      <div class="hud-wave">
        <span class="hud-label">WAVE</span>
        <span class="hud-value">{{ wave }}</span>
      </div>
      <div class="hud-bomb">
        <span class="hud-label">BOMB (W)</span>
        <span class="hud-value" :class="{ ready: bombs > 0 }">{{ bombs }}</span>
      </div>
      <div class="hud-sound">
        <span class="hud-label">SOUND (M)</span>
        <span class="hud-value" :class="{ ready: !muted }">{{ muted ? 'OFF' : 'ON' }}</span>
      </div>
    </div>

    <div class="overlay" v-if="!started">
      <h1 class="overlay-title">星 际 大 战</h1>
      <p class="overlay-sub">移动鼠标 / 触屏滑动控制战机 · 自动开火 · 点击左键或轻点暂停/继续 · W 键释放炸弹 · M 键静音</p>
      <button class="start-btn" @click="startGame">开 始 战 斗</button>
    </div>

    <div class="pause-tip" v-if="started && paused && !gameOver">
      <div class="pause-icon">⏸</div>
      <div class="pause-text">已 暂 停</div>
      <div class="pause-sub">点击鼠标左键继续</div>
    </div>

    <div class="overlay" v-if="gameOver">
      <h1 class="overlay-title dead">战 机 坠 毁</h1>
      <p class="overlay-sub">最终得分：{{ score }} · 存活波次：{{ wave }}</p>
      <p v-if="rewardTip" class="overlay-reward">{{ rewardTip }}</p>
      <button class="start-btn" @click="startGame">再 来 一 局</button>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import HeaderNav from "@/components/HeaderNav.vue"
import { saveGameScore } from '@/api/gameScore' 

export default {
  name: 'Travel',
  components: { HeaderNav },
  data() {
    return {
      started: false,
      gameOver: false,
      score: 0,
      hp: 100,
      wave: 1,
      bombs: 1,
      bossActive: false,
      bossHp: 0,
      bossMaxHp: 60,
      shieldCharge: 0,
      muted: false,
      paused: false,
      audioCtx: null,
      gameRef: null,
      rewardTip: '',
      scoreSaved: false
    }
  },
  computed: {
    hpPercent() { return Math.max(0, this.hp) },
    bossHpPct() { return this.bossMaxHp > 0 ? Math.max(0, this.bossHp / this.bossMaxHp * 100) : 0 }
  },
  watch: {
    // 暂停时释放鼠标指针（游戏进行中隐藏指针，暂停时显示以便点击继续）
    paused(v) {
      const c = this.$refs.gameCanvas
      if (c) c.style.cursor = v ? 'default' : 'none'
    }
  },
  beforeDestroy() {
    if (this.gameRef) this.gameRef.stop()
  },
  methods: {
    startGame() {
      this.started = true
      this.gameOver = false
      this.score = 0
      this.hp = 100
      this.wave = 1
      this.bombs = 1
      this.bossActive = false
      this.bossHp = 0
      this.shieldCharge = 0
      this.paused = false
      this.rewardTip = ''
      this.scoreSaved = false
      this.initAudio()
      this.$nextTick(() => this.initGame())
    },
    submitScore() {
      if (this.scoreSaved || this.score <= 0) return
      this.scoreSaved = true
      try {
        const u = JSON.parse(sessionStorage.getItem('CurUser') || '{}')
        if (!u.no) { this.rewardTip = ''; return }
        const self = this
        saveGameScore({ userId: u.id, no: u.no, score: this.score, gameType: 'space' }).then(res => {
          if (res && res.code === 200) {
            const reward = res.data && res.data.rewardCoin
            self.rewardTip = (reward && reward > 0) ? ('超出 1500 分，奖励 ' + reward + ' 星裙币') : '成绩已保存'
          } else {
            self.rewardTip = ''
          }
        }).catch(() => { self.rewardTip = '' })
      } catch (e) { /* ignore */ }
    },
    initAudio() {
      if (!this.audioCtx) {
        const AC = window.AudioContext || window.webkitAudioContext
        if (!AC) return
        this.audioCtx = new AC()
      }
      if (this.audioCtx.state === 'suspended') this.audioCtx.resume()
    },
    makeGlowSprite(r, g, b, size) {
      const c = document.createElement('canvas')
      c.width = size; c.height = size
      const g2 = c.getContext('2d')
      const grad = g2.createRadialGradient(size/2, size/2, 0, size/2, size/2, size/2)
      grad.addColorStop(0, 'rgba(' + r + ',' + g + ',' + b + ',1)')
      grad.addColorStop(0.3, 'rgba(' + r + ',' + g + ',' + b + ',0.5)')
      grad.addColorStop(1, 'rgba(' + r + ',' + g + ',' + b + ',0)')
      g2.fillStyle = grad
      g2.fillRect(0, 0, size, size)
      return c
    },
    initGame() {
      const wrap = this.$refs.gameWrap
      const canvas = this.$refs.gameCanvas
      const W = wrap.clientWidth
      const H = wrap.clientHeight
      const ctx = canvas.getContext('2d')
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5)
      canvas.width = W * dpr
      canvas.height = H * dpr
      ctx.scale(dpr, dpr)

      const spPink = this.makeGlowSprite(255, 184, 230, 32)
      const spRed = this.makeGlowSprite(255, 100, 130, 24)
      const spPurple = this.makeGlowSprite(192, 132, 252, 36)
      const spBullet = this.makeGlowSprite(255, 220, 245, 20)
      const spCyan = this.makeGlowSprite(130, 220, 255, 20)
      const spGold = this.makeGlowSprite(255, 220, 130, 20)
      const spGreen = this.makeGlowSprite(130, 255, 180, 28)
      const spShield = this.makeGlowSprite(100, 200, 255, 40)
      const spBomb = this.makeGlowSprite(255, 160, 80, 30)

      // 僚机：每个独立阻尼系数，外僚机更滞后
      const wingmen = [
        { dx: -42, dy: 18, color: 'cyan', x: 0, y: 0, ease: 0.08 },
        { dx: -26, dy: 32, color: 'gold', x: 0, y: 0, ease: 0.15 },
        { dx: 26, dy: 32, color: 'gold', x: 0, y: 0, ease: 0.15 },
        { dx: 42, dy: 18, color: 'cyan', x: 0, y: 0, ease: 0.08 }
      ]

      const G = {
        w: W, h: H,
        player: { x: W/2, y: H-80, r: 14, invincible: 0, shield: 0 },
        bullets: [], enemies: [], enemyBullets: [],
        particles: [], stars: [], items: [],
        wingmen,
        power: 1, powerTimer: 0,
        slowTimer: 0,
        bombFlash: 0,
        mouseX: W/2, mouseY: H-80,
        fireTimer: 0, spawnTimer: 0, waveTimer: 0, itemTimer: 0,
        bossActive: false,
        raf: null, running: true
      }

      for (const w of G.wingmen) {
        w.x = G.player.x + w.dx
        w.y = G.player.y + w.dy
      }

      for (let i = 0; i < 70; i++) {
        G.stars.push({
          x: Math.random()*W, y: Math.random()*H,
          r: Math.random()<0.5?1:2, speed: Math.random()*1.5+0.3
        })
      }

      const self = this

      // ===== 音效系统（Web Audio 实时合成，无需外部音频文件） =====
      const audioCtx = this.audioCtx
      const playTone = (freq, dur, type, vol, slideTo) => {
        if (self.muted || !audioCtx) return
        const t = audioCtx.currentTime
        const o = audioCtx.createOscillator()
        const g = audioCtx.createGain()
        o.type = type || 'square'
        o.frequency.setValueAtTime(freq, t)
        if (slideTo) o.frequency.exponentialRampToValueAtTime(slideTo, t + dur)
        g.gain.setValueAtTime(vol, t)
        g.gain.exponentialRampToValueAtTime(0.0001, t + dur)
        o.connect(g)
        g.connect(audioCtx.destination)
        o.start(t)
        o.stop(t + dur + 0.05)
      }
      const playNoise = (dur, vol, cutoff) => {
        if (self.muted || !audioCtx) return
        const t = audioCtx.currentTime
        const len = Math.max(1, Math.floor(audioCtx.sampleRate * dur))
        const buf = audioCtx.createBuffer(1, len, audioCtx.sampleRate)
        const d = buf.getChannelData(0)
        for (let i = 0; i < len; i++) d[i] = (Math.random()*2-1) * (1 - i/len)
        const src = audioCtx.createBufferSource()
        src.buffer = buf
        const f = audioCtx.createBiquadFilter()
        f.type = 'lowpass'
        f.frequency.value = cutoff || 900
        const g = audioCtx.createGain()
        g.gain.setValueAtTime(vol, t)
        g.gain.exponentialRampToValueAtTime(0.0001, t + dur)
        src.connect(f)
        f.connect(g)
        g.connect(audioCtx.destination)
        src.start(t)
      }
      const sfx = {
        shot()      { playTone(920, 0.07, 'square', 0.05, 420) },
        enemyDown() { playNoise(0.22, 0.16, 1400); playTone(220, 0.2, 'triangle', 0.12, 60) },
        bossDown()  { playNoise(0.7, 0.28, 900); playTone(160, 0.7, 'sawtooth', 0.18, 40) },
        hit()       { playTone(200, 0.25, 'sawtooth', 0.2, 70); playNoise(0.15, 0.14, 1000) },
        pickup(type) {
          const base = type === 'bomb' ? 660 : type === 'shield' ? 740 : type === 'slow' ? 587 : 523
          playTone(base, 0.08, 'triangle', 0.12)
          playTone(base*1.5, 0.1, 'triangle', 0.12)
        },
        shield()    { playTone(520, 0.28, 'sine', 0.16, 1320) },
        bomb()      { playNoise(0.65, 0.3, 700); playTone(120, 0.6, 'sawtooth', 0.2, 30) },
        bossAlert() { playTone(110, 0.35, 'sawtooth', 0.2, 82); playTone(82, 0.4, 'sawtooth', 0.18, 55); playNoise(0.3, 0.12, 500) },
        wave()      { playTone(440, 0.09, 'triangle', 0.1); playTone(660, 0.12, 'triangle', 0.1) },
        gameOver()  { playTone(392, 0.5, 'sawtooth', 0.22, 98); playTone(196, 0.9, 'triangle', 0.18, 49) }
      }

      const onMove = (e) => {
        const rect = canvas.getBoundingClientRect()
        G.mouseX = e.clientX - rect.left
        G.mouseY = e.clientY - rect.top
      }
      wrap.addEventListener('mousemove', onMove)

      // 左键点击：暂停 / 继续游戏
      const onMouseDown = (e) => {
        if (!self.started || self.gameOver) return
        if (e.button !== 0) return
        // 点击时同步一次鼠标位置，避免恢复后战机瞬移
        const rect = canvas.getBoundingClientRect()
        G.mouseX = e.clientX - rect.left
        G.mouseY = e.clientY - rect.top
        self.paused = !self.paused
        if (!self.paused) {
          // 恢复：重新启动游戏循环
          G.raf = requestAnimationFrame(tick)
        }
      }
      wrap.addEventListener('mousedown', onMouseDown)

      // ===== 触屏控制：滑动控制战机 · 轻点暂停/继续 =====
      let touchStartX = 0, touchStartY = 0, touchMoved = false
      const onTouchStart = (e) => {
        if (!self.started || self.gameOver) return
        e.preventDefault()
        const t = e.touches[0]
        const rect = canvas.getBoundingClientRect()
        touchStartX = t.clientX
        touchStartY = t.clientY
        touchMoved = false
        // 起点即目标点，避免恢复/开始后战机瞬移
        G.mouseX = t.clientX - rect.left
        G.mouseY = t.clientY - rect.top
      }
      const onTouchMove = (e) => {
        if (!self.started || self.gameOver || self.paused) return
        e.preventDefault()
        const t = e.touches[0]
        const dx = t.clientX - touchStartX
        const dy = t.clientY - touchStartY
        // 超过阈值判定为滑动（区分轻点暂停）
        if (!touchMoved && (Math.abs(dx) > 12 || Math.abs(dy) > 12)) {
          touchMoved = true
        }
        if (touchMoved) {
          const rect = canvas.getBoundingClientRect()
          G.mouseX = t.clientX - rect.left
          G.mouseY = t.clientY - rect.top
        }
      }
      const onTouchEnd = (e) => {
        if (!self.started || self.gameOver) return
        e.preventDefault()
        // 轻点（未滑动）→ 暂停 / 继续
        if (!touchMoved) {
          self.paused = !self.paused
          if (!self.paused) {
            G.raf = requestAnimationFrame(tick)
          }
        }
        touchMoved = false
      }
      wrap.addEventListener('touchstart', onTouchStart, { passive: false })
      wrap.addEventListener('touchmove', onTouchMove, { passive: false })
      wrap.addEventListener('touchend', onTouchEnd, { passive: false })

      const useBomb = () => {
        if (self.bombs <= 0 || !G.running) return
        self.bombs--
        G.enemyBullets.length = 0
        for (let i = G.enemies.length-1; i >= 0; i--) {
          const e = G.enemies[i]
          e.hp -= e.type === 'boss' ? 40 : 20
          if (e.hp <= 0) {
            explode(e.x, e.y, 20, spBomb)
            G.enemies.splice(i, 1)
            self.score += 50
          }
        }
        explode(G.player.x, G.player.y, 40, spBomb)
        sfx.bomb()
        G.bombFlash = 1
      }

      const onKey = (e) => {
        if (self.paused) return
        if (e.key === 'w' || e.key === 'W') useBomb()
        if (e.key === 'm' || e.key === 'M') self.muted = !self.muted
      }
      window.addEventListener('keydown', onKey)

      function spawnNormal() {
        const types = ['grunt', 'zigzag', 'shooter', 'shielded', 'splitter']
        const type = types[Math.floor(Math.random()*types.length)]
        const stats = {
          grunt:    { hp: 1, r: 14, speed: 1.5 },
          zigzag:   { hp: 1, r: 14, speed: 2.5 },
          shooter:  { hp: 3, r: 20, speed: 1.2 },
          shielded: { hp: 3, r: 18, speed: 1.0 },
          splitter: { hp: 2, r: 18, speed: 1.8 }
        }[type]
        G.enemies.push({
          x: 60+Math.random()*(W-120), y: -40, type,
          hp: stats.hp, r: stats.r, speed: stats.speed,
          phase: Math.random()*Math.PI*2,
          fireTimer: 60+Math.random()*60,
          shield: type === 'shielded' ? 2 : 0
        })
      }

      function spawnBoss() {
        G.bossActive = true
        self.bossActive = true
        self.bossMaxHp = 120
        self.bossHp = 120
        G.enemies.push({
          x: W/2, y: -80, type: 'boss',
          hp: 120, maxHp: 120, r: 100, speed: 1.0,
          phase: 0, fireTimer: 30, shield: 0
        })
        sfx.bossAlert()
      }

      function enemyShoot(e) {
        const dx = G.player.x - e.x, dy = G.player.y - e.y
        const d = Math.sqrt(dx*dx + dy*dy) || 1
        const sp = 3.5
        if (e.type === 'shooter') {
          for (let a = -0.2; a <= 0.2; a += 0.2) {
            G.enemyBullets.push({ x:e.x, y:e.y+10, vx:(dx/d)*sp+a*3, vy:(dy/d)*sp, r:5 })
          }
        } else if (e.type === 'boss') {
          for (let i = 0; i < 8; i++) {
            const a = (i/8)*Math.PI*2
            G.enemyBullets.push({ x:e.x, y:e.y, vx:Math.cos(a)*2.5, vy:Math.sin(a)*2.5, r:5 })
          }
        } else {
          G.enemyBullets.push({ x:e.x, y:e.y+10, vx:(dx/d)*sp, vy:(dy/d)*sp, r:4 })
        }
      }

      function explode(x, y, count, sprite) {
        for (let i = 0; i < count; i++) {
          const a = Math.random()*Math.PI*2
          const sp = Math.random()*3.5+1
          G.particles.push({
            x, y, vx:Math.cos(a)*sp, vy:Math.sin(a)*sp,
            life:1, decay:0.03+Math.random()*0.02,
            size:Math.random()*16+8, sprite
          })
        }
      }

      function killEnemy(i) {
        const e = G.enemies[i]
        if (e.type === 'boss') sfx.bossDown(); else sfx.enemyDown()
        explode(e.x, e.y, 15, spPink)
        self.score += e.type === 'boss' ? 500 : (e.type === 'shooter' || e.type === 'shielded' ? 30 : 10)
        if (e.type === 'splitter') {
          for (let k = 0; k < 2; k++) {
            G.enemies.push({
              x: e.x + (k===0?-20:20), y: e.y, type: 'grunt',
              hp: 1, r: 10, speed: 3, phase: Math.random()*Math.PI*2,
              fireTimer: 999
            })
          }
        }
        if (e.type === 'shielded' || e.type === 'shooter' || e.type === 'boss') {
          G.items.push({
            x: e.x, y: e.y, vy: 1.5,
            type: e.type === 'boss' ? 'bomb' : (Math.random() < 0.5 ? 'shield' : 'power')
          })
        }
        if (e.type === 'boss') { G.bossActive = false; self.bossActive = false }
        G.enemies.splice(i, 1)
      }

      const tick = () => {
        if (!G.running) return
        // 暂停：冻结游戏循环，画面停留在当前帧
        if (self.paused) return
        const slowFactor = G.slowTimer > 0 ? 0.4 : 1

        for (const s of G.stars) {
          s.y += s.speed
          if (s.y > H) { s.y = -2; s.x = Math.random()*W }
        }

        G.player.x += (G.mouseX - G.player.x) * 0.35
        G.player.y += (G.mouseY - G.player.y) * 0.35
        G.player.x = Math.max(20, Math.min(W-20, G.player.x))
        G.player.y = Math.max(80, Math.min(H-30, G.player.y))
        if (G.player.invincible > 0) G.player.invincible--
        if (G.player.shield > 0) {
          G.player.shield--
          self.shieldCharge = (G.player.shield / 600) * 100
        }

        // 僚机独立弹簧阻尼跟随
        for (const w of G.wingmen) {
          const tx = G.player.x + w.dx
          const ty = G.player.y + w.dy
          w.x += (tx - w.x) * w.ease
          w.y += (ty - w.y) * w.ease
        }

        if (G.powerTimer > 0) { G.powerTimer--; if (G.powerTimer === 0) G.power = 1 }
        if (G.slowTimer > 0) G.slowTimer--

        G.fireTimer++
        if (G.fireTimer >= 9) {
          G.bullets.push({ x:G.player.x-6, y:G.player.y-10, vy:-13, color:'pink' })
          G.bullets.push({ x:G.player.x+6, y:G.player.y-10, vy:-13, color:'pink' })
          if (G.power >= 2) {
            G.bullets.push({ x:G.player.x-10, y:G.player.y-6, vy:-12, vx:-1.5, color:'pink' })
            G.bullets.push({ x:G.player.x+10, y:G.player.y-6, vy:-12, vx:1.5, color:'pink' })
          }
          if (G.power >= 3) {
            G.bullets.push({ x:G.player.x, y:G.player.y-14, vy:-15, color:'gold', pierce:true })
          }
          for (const w of G.wingmen) {
            G.bullets.push({ x:w.x, y:w.y-8, vy:-11, color:w.color })
          }
          sfx.shot()
          G.fireTimer = 0
        }

        G.spawnTimer++
        const spawnRate = Math.max(30, 80 - self.wave*4)
        if (G.spawnTimer >= spawnRate && !G.bossActive) { spawnNormal(); G.spawnTimer = 0 }

        G.waveTimer++
        if (G.waveTimer >= 600) {
          self.wave++
          sfx.wave()
          G.waveTimer = 0
          if (self.wave % 10 === 0 && !G.bossActive) spawnBoss()
        }

        G.itemTimer++
        if (G.itemTimer >= 350) {
          G.itemTimer = 0
          const r = Math.random()
          const type = r < 0.3 ? 'power' : r < 0.55 ? 'heal' : r < 0.7 ? 'slow' : r < 0.8 ? 'bomb' : 'shield'
          G.items.push({ x:60+Math.random()*(W-120), y:-20, vy:1.5, type })
        }

        for (let i = G.items.length-1; i >= 0; i--) {
          const it = G.items[i]
          const dx = it.x - G.player.x, dy = it.y - G.player.y
          const dist = Math.sqrt(dx*dx + dy*dy) || 1
          if (it.type === 'shield' && dist < 120) {
            it.x -= (dx/dist)*3
            it.y -= (dy/dist)*3
          }
          it.y += it.vy
          if (it.y > H+30) { G.items.splice(i,1); continue }
          if (dist < 32) {
            if (it.type === 'power') { self.power = Math.min(3, self.power+1); G.powerTimer = 600 }
            else if (it.type === 'heal') { self.hp = Math.min(100, self.hp+25) }
            else if (it.type === 'slow') { G.slowTimer = 300 }
            else if (it.type === 'bomb') { self.bombs = Math.min(5, self.bombs+1) }
            else if (it.type === 'shield') {
              if (G.player.shield > 0) {
                G.player.shield = Math.min(900, G.player.shield + 300)
              } else {
                self.shieldCharge = Math.min(100, self.shieldCharge + 34)
                if (self.shieldCharge >= 100) {
                  G.player.shield = 600
                  self.shieldCharge = 100
                  sfx.shield()
                }
              }
            }
            sfx.pickup(it.type)
            explode(it.x, it.y, 10, spCyan)
            G.items.splice(i,1)
          }
        }

        for (let i = G.bullets.length-1; i >= 0; i--) {
          const b = G.bullets[i]
          b.x += (b.vx||0); b.y += b.vy
          if (b.y < -20) G.bullets.splice(i,1)
        }

        for (let i = G.enemies.length-1; i >= 0; i--) {
          const e = G.enemies[i]
          e.phase += 0.03 * slowFactor
          e.y += e.speed * slowFactor
          if (e.type === 'zigzag') e.x += Math.sin(e.phase)*2
          if (e.type === 'boss') {
            // 战斗区域边界：只允许在上半屏内移动，且不超出屏幕
            const minX = e.r
            const maxX = W - e.r
            const minY = 90
            const maxY = Math.max(minY + 40, H * 0.5 - e.r)
            if (e.y < minY) {
              // 入场：从顶部下降到战斗区域
              e.x += (W/2 - e.x) * 0.1
              e.y += 1.5
            } else {
              // 随机巡航：在上半屏内随机选择目标点并平滑移动
              if (e.tx == null || e.ty == null) {
                e.tx = minX + Math.random() * Math.max(0, maxX - minX)
                e.ty = minY + Math.random() * (maxY - minY)
              }
              e.x += (e.tx - e.x) * 0.02
              e.y += (e.ty - e.y) * 0.02
              if (Math.abs(e.x - e.tx) < 4 && Math.abs(e.y - e.ty) < 4) {
                e.tx = minX + Math.random() * Math.max(0, maxX - minX)
                e.ty = minY + Math.random() * (maxY - minY)
              }
              e.x = Math.max(minX, Math.min(maxX, e.x))
              e.y = Math.max(minY, Math.min(maxY, e.y))
            }
          }
          e.fireTimer--
          if (e.fireTimer <= 0 && e.y > 0 && e.y < H-100) {
            enemyShoot(e)
            e.fireTimer = e.type === 'boss' ? 40 : (e.type === 'shooter' ? 80+Math.random()*40 : 100+Math.random()*80)
          }
          if (e.y > H+40) { G.enemies.splice(i,1); continue }

          for (let j = G.bullets.length-1; j >= 0; j--) {
            const b = G.bullets[j]
            const dx = b.x-e.x, dy = b.y-e.y
            if (dx*dx+dy*dy < e.r*e.r) {
              if (e.shield > 0) {
                e.shield--
                explode(b.x, b.y, 4, spCyan)
              } else {
                e.hp--
              }
              if (!b.pierce) G.bullets.splice(j,1)
              if (e.hp <= 0) killEnemy(i)
              else if (e.type === 'boss') self.bossHp = e.hp
              break
            }
          }
          const pdx = e.x-G.player.x, pdy = e.y-G.player.y
          const pr = e.r+G.player.r
          if (pdx*pdx+pdy*pdy < pr*pr && G.player.invincible <= 0) {
            if (G.player.shield > 0) {
              G.player.shield = 0
              sfx.shield()
              explode(e.x, e.y, 15, spCyan)
              G.enemies.splice(i,1)
            } else {
              explode(e.x, e.y, 15, spPink)
              G.enemies.splice(i,1)
              self.hp -= 25
              sfx.hit()
              G.player.invincible = 60
            }
          }
        }

        for (let i = G.enemyBullets.length-1; i >= 0; i--) {
          const b = G.enemyBullets[i]
          b.x += b.vx; b.y += b.vy
          if (b.y<-20 || b.y>H+20 || b.x<-20 || b.x>W+20) { G.enemyBullets.splice(i,1); continue }
          const dx = b.x-G.player.x, dy = b.y-G.player.y
          if (dx*dx+dy*dy < (b.r+G.player.r)*(b.r+G.player.r) && G.player.invincible <= 0) {
            G.enemyBullets.splice(i,1)
            if (G.player.shield > 0) {
              G.player.shield = 0
              explode(G.player.x, G.player.y, 10, spCyan)
            } else {
              self.hp -= 8
              sfx.hit()
              G.player.invincible = 30
              explode(G.player.x, G.player.y, 8, spRed)
            }
          }
        }

        for (let i = G.particles.length-1; i >= 0; i--) {
          const p = G.particles[i]
          p.x += p.vx; p.y += p.vy; p.life -= p.decay
          if (p.life <= 0) G.particles.splice(i,1)
        }

        if (G.bombFlash > 0) G.bombFlash -= 0.04
        if (self.hp <= 0) {
          self.gameOver = true
          G.running = false
          sfx.gameOver()
          if (this.gameRef) this.gameRef.stop()
          self.submitScore()
        }

        /* ===== 绘制 ===== */
        ctx.fillStyle = '#0a0518'
        ctx.fillRect(0, 0, W, H)
        ctx.fillStyle = 'rgba(200,220,255,0.6)'
        for (const s of G.stars) ctx.fillRect(s.x, s.y, s.r, s.r)

        ctx.globalCompositeOperation = 'lighter'

        if (G.bombFlash > 0) {
          ctx.fillStyle = 'rgba(255,200,100,' + (G.bombFlash*0.4) + ')'
          ctx.fillRect(0, 0, W, H)
        }

        for (const p of G.particles) {
          ctx.globalAlpha = p.life
          const s = p.size*p.life
          ctx.drawImage(p.sprite, p.x-s/2, p.y-s/2, s, s)
        }

        ctx.globalAlpha = 1
        for (const b of G.bullets) {
          const sp = b.color==='cyan' ? spCyan : (b.color==='gold' ? spGold : spBullet)
          const s = b.pierce ? 16 : 12
          ctx.drawImage(sp, b.x-s/2, b.y-s, s, s*1.8)
          ctx.fillStyle = '#fff'
          ctx.fillRect(b.x-1.5, b.y-10, 3, 14)
        }

        for (const b of G.enemyBullets) {
          const s = b.r*3
          ctx.drawImage(spRed, b.x-s/2, b.y-s/2, s, s)
        }

        for (const e of G.enemies) {
          const gs = e.r*3.5
          let sp = spRed
          if (e.type === 'shooter' || e.type === 'boss') sp = spPurple
          else if (e.type === 'shielded') sp = spCyan
          else if (e.type === 'splitter') sp = spGold
          ctx.drawImage(sp, e.x-gs/2, e.y-gs/2, gs, gs)
          ctx.fillStyle = e.type==='shooter' ? '#c084fc' :
                           e.type==='shielded' ? '#4ecdc4' :
                           e.type==='splitter' ? '#ffd700' : '#ff4466'
          ctx.beginPath()
          if (e.type === 'boss') {
            ctx.moveTo(e.x, e.y+60); ctx.lineTo(e.x+70, e.y-30)
            ctx.lineTo(e.x+30, e.y-10); ctx.lineTo(e.x-30, e.y-10)
            ctx.lineTo(e.x-70, e.y-30)
          } else if (e.type === 'shooter') {
            ctx.moveTo(e.x, e.y+16); ctx.lineTo(e.x+14, e.y-8)
            ctx.lineTo(e.x, e.y-2); ctx.lineTo(e.x-14, e.y-8)
          } else if (e.type === 'shielded') {
            ctx.moveTo(e.x, e.y-14); ctx.lineTo(e.x+12, e.y+10)
            ctx.lineTo(e.x, e.y+4); ctx.lineTo(e.x-12, e.y+10)
          } else {
            ctx.moveTo(e.x, e.y-12); ctx.lineTo(e.x+10, e.y+8); ctx.lineTo(e.x-10, e.y+8)
          }
          ctx.closePath()
          ctx.fill()
          if (e.shield > 0) {
            ctx.strokeStyle = 'rgba(100,200,255,' + (0.4+0.3*Math.sin(e.phase*3)) + ')'
            ctx.lineWidth = 2
            ctx.beginPath()
            ctx.arc(e.x, e.y, e.r+5, 0, Math.PI*2)
            ctx.stroke()
          }
        }

        for (const it of G.items) {
          const sp = it.type==='shield' ? spCyan : it.type==='bomb' ? spBomb :
                     it.type==='slow' ? spGreen : spGold
          const s = it.type==='shield' ? 24 : 28
          ctx.drawImage(sp, it.x-s/2, it.y-s/2, s, s)
          ctx.fillStyle = '#fff'
          ctx.font = 'bold 11px sans-serif'
          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          const label = it.type==='power' ? 'P' : it.type==='heal' ? '+' :
                        it.type==='slow' ? 'S' : it.type==='bomb' ? 'B' : 'C'
          ctx.fillText(label, it.x, it.y)
        }

        for (const w of G.wingmen) {
          const sp = w.color==='cyan' ? spCyan : spGold
          ctx.drawImage(sp, w.x-10, w.y-10, 20, 20)
          ctx.fillStyle = w.color==='cyan' ? '#8edcff' : '#ffdc82'
          ctx.beginPath()
          ctx.moveTo(w.x, w.y-8); ctx.lineTo(w.x+6, w.y+6); ctx.lineTo(w.x-6, w.y+6)
          ctx.closePath()
          ctx.fill()
        }

        if (!(G.player.invincible > 0 && Math.floor(G.player.invincible/4)%2 === 0)) {
          ctx.drawImage(spPink, G.player.x-22, G.player.y-22, 44, 44)
          ctx.fillStyle = '#ffb8e6'
          ctx.beginPath()
          ctx.moveTo(G.player.x, G.player.y-18)
          ctx.lineTo(G.player.x+12, G.player.y+12)
          ctx.lineTo(G.player.x+5, G.player.y+8)
          ctx.lineTo(G.player.x, G.player.y+14)
          ctx.lineTo(G.player.x-5, G.player.y+8)
          ctx.lineTo(G.player.x-12, G.player.y+12)
          ctx.closePath()
          ctx.fill()
          ctx.fillStyle = '#fff'
          ctx.beginPath()
          ctx.arc(G.player.x, G.player.y-4, 3, 0, Math.PI*2)
          ctx.fill()
        }

        if (G.player.shield > 0) {
          const sa = G.player.shield/600
          ctx.globalAlpha = 0.3*sa
          ctx.drawImage(spShield, G.player.x-35, G.player.y-35, 70, 70)
          ctx.globalAlpha = 1
          ctx.strokeStyle = 'rgba(140,225,255,' + (0.45 + 0.3*Math.sin(G.raf*0.02) + 0.25*sa) + ')'
          ctx.lineWidth = 2.5
          ctx.beginPath()
          ctx.arc(G.player.x, G.player.y, 30, 0, Math.PI*2)
          ctx.stroke()
        }

        ctx.globalAlpha = 1
        ctx.globalCompositeOperation = 'source-over'
        G.raf = requestAnimationFrame(tick)
      }
      tick()

      this.gameRef = {
        stop: () => {
          G.running = false
          cancelAnimationFrame(G.raf)
          wrap.removeEventListener('mousemove', onMove)
          wrap.removeEventListener('mousedown', onMouseDown)
          wrap.removeEventListener('touchstart', onTouchStart)
          wrap.removeEventListener('touchmove', onTouchMove)
          wrap.removeEventListener('touchend', onTouchEnd)
          window.removeEventListener('keydown', onKey)
        }
      }
    }
  }
}
</script>

<style scoped>
.travel-game {
  position: fixed;
  inset: 0;
  padding-top: 60px;
  overflow: hidden;
  background: #0a0518;
}
.game-wrap { position: relative; width: 100%; height: 100%; touch-action: none; }
.game-wrap canvas { display: block; width: 100% !important; height: 100% !important; cursor: none; }

.hud {
  position: absolute; left: 20px; right: 20px;
  display: flex; justify-content: space-between; align-items: flex-start;
  z-index: 5; pointer-events: none;
}
.hud-bottom { bottom: 20px; }
.hud-label { display: block; font-size: 10px; letter-spacing: 3px; color: rgba(255,200,240,0.5); margin-bottom: 4px; }
.hud-value { font-size: 24px; font-weight: 300; color: #ffb8e6; text-shadow: 0 0 10px rgba(255,150,220,0.5); }
.hud-value.ready { color: #ffdc82; }
.hud-hp { width: 140px; }
.hud-shield { width: 140px; }
.hp-bar { width: 100%; height: 8px; background: rgba(255,100,150,0.15); border-radius: 4px; overflow: hidden; margin-top: 4px; }
.hp-fill { height: 100%; background: linear-gradient(90deg, #ff6699, #ffb8e6); border-radius: 4px; transition: width 0.3s; }
.shield-bar { background: rgba(100,200,255,0.15); }
.shield-fill { background: linear-gradient(90deg, #4ecdc4, #8edcff); }

.boss-bar {
  position: absolute; top: 80px; left: 50%; transform: translateX(-50%);
  width: 60%; max-width: 600px; z-index: 5; pointer-events: none;
  text-align: center;
}
.boss-label { display: block; font-size: 11px; letter-spacing: 6px; color: rgba(255,100,130,0.8); margin-bottom: 6px; }
.boss-bar-track { width: 100%; height: 10px; background: rgba(255,80,100,0.15); border-radius: 5px; overflow: hidden; }
.boss-bar-fill { height: 100%; background: linear-gradient(90deg, #ff4466, #ff8899); border-radius: 5px; transition: width 0.2s; }

.overlay {
  position: absolute; inset: 0; display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  background: radial-gradient(ellipse at center, rgba(30,10,50,0.9), rgba(10,5,24,0.95));
  z-index: 10;
}
.overlay-title {
  font-size: 42px; font-weight: 300; letter-spacing: 16px; margin: 0;
  background: linear-gradient(135deg, #ffd6f0, #ff9ed8, #c084fc);
  -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
}
.overlay-title.dead {
  background: linear-gradient(135deg, #ff6688, #ff4466);
  -webkit-background-clip: text; background-clip: text;
}
.overlay-sub { font-size: 14px; color: rgba(255,200,240,0.5); letter-spacing: 2px; margin: 16px 0 30px; }

/* ===== 暂停提示层 ===== */
.pause-tip {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 8;
  background: rgba(10, 5, 24, 0.55);
  backdrop-filter: blur(2px);
  pointer-events: none; /* 让点击穿透到游戏区，实现"点击任意位置继续" */
}
.pause-icon {
  font-size: 52px;
  color: #ffb8e6;
  text-shadow: 0 0 20px rgba(255, 150, 220, 0.6);
  animation: pausePulse 1.6s ease infinite;
}
.pause-text {
  margin-top: 18px;
  font-size: 30px;
  font-weight: 300;
  letter-spacing: 12px;
  color: #ffb8e6;
  text-shadow: 0 0 12px rgba(255, 150, 220, 0.5);
}
.pause-sub {
  margin-top: 12px;
  font-size: 14px;
  letter-spacing: 2px;
  color: rgba(255, 200, 240, 0.6);
}
@keyframes pausePulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.65; transform: scale(1.08); }
}
.start-btn {
  padding: 14px 50px; background: transparent;
  border: 1px solid rgba(255,150,220,0.5); color: #ffb8e6;
  font-size: 16px; letter-spacing: 6px; cursor: pointer; border-radius: 30px;
  transition: all 0.3s; font-family: inherit;
}
.start-btn:hover {
  background: rgba(255,120,200,0.15); border-color: #ff8ad4;
  box-shadow: 0 0 25px rgba(255,150,220,0.4); transform: scale(1.05);
}
</style>
